import { useState } from "react";
import AccessAudit from "@/pages/AccessAudit";

const TABS = [["access", "Access audit"]];

export default function Settings() {
  const [tab, setTab] = useState("access");
  return (
    <div className="flex-1 min-w-0 flex flex-col min-h-0" data-testid="settings-page">
      <div className="px-8 pt-6 flex items-center gap-4 border-b border-slate-200 bg-white/60">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 pb-3">Settings</h1>
        <div className="flex gap-1">{TABS.map(([k, l]) => <button key={k} data-testid={`settings-tab-${k}`} onClick={() => setTab(k)} className={`text-xs font-semibold px-3 py-2 border-b-2 ${tab === k ? "border-sky-600 text-sky-700" : "border-transparent text-slate-500"}`}>{l}</button>)}</div>
      </div>
      {tab === "access" && <AccessAudit />}
    </div>
  );
}
